import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Button } from './ui/button';
import { cn } from '../lib/utils';
import { Bus, PlusCircle, List, PieChart, MapPin, User, LogOut, Menu, X } from 'lucide-react';

const NavigationBar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navItems = [
    { path: '/', label: '記錄表單', icon: PlusCircle },
    { path: '/records', label: '記錄列表', icon: List },
    { path: '/stats', label: '巴士統計', icon: PieChart },
    { path: '/map', label: '巴士站地圖', icon: MapPin },
  ];

  const handleNavClick = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-gradient-to-r from-blue-500 to-green-500 text-white shadow-lg" style={{ paddingTop: 'env(safe-area-inset-top)', paddingLeft: 'env(safe-area-inset-left)', paddingRight: 'env(safe-area-inset-right)' }}>
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          {/* Logo/Brand */}
          <Link 
            to="/" 
              className="flex items-center space-x-2 font-semibold text-white hover:opacity-80 transition-opacity"
            >
            <Bus className="h-6 w-6" />
            <span className="text-lg">巴士記錄系統</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <Button
                  key={item.path}
                  variant="ghost"
                  size="sm"
                  className={cn(
                    "text-white hover:bg-white/10 hover:text-white",
                    isActive(item.path) && "bg-white/20"
                  )}
                  onClick={() => handleNavClick(item.path)}
            >
                  <Icon className="mr-2 h-4 w-4" />
                  {item.label}
                </Button>
              );
            })}
          </div>

          {/* User Info & Actions */}
          <div className="hidden md:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-sm">
              <User className="h-4 w-4" />
              <span>歡迎, {user?.username}</span>
            </div>
            <Button 
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="border-white/20 text-white hover:bg-white/10 bg-white/5"
            >
              <LogOut className="mr-2 h-4 w-4" />
              登出
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden text-white hover:bg-white/10"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </Button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div 
            className="md:hidden border-t border-white/20 py-4"
            style={{ paddingBottom: 'max(1rem, env(safe-area-inset-bottom))' }}
          >
            <div className="flex flex-col space-y-2">
              {navItems.map((item) => {
                const Icon = item.icon;
                return (
                  <Button
                    key={item.path}
                    variant="ghost"
                    className={cn(
                      "w-full justify-start text-white hover:bg-white/10",
                      isActive(item.path) && "bg-white/20"
                    )}
                    onClick={() => handleNavClick(item.path)}
                  >
                    <Icon className="mr-2 h-4 w-4" />
                    {item.label}
                  </Button>
                );
              })}
              <div className="pt-4 border-t border-white/20 mt-2">
                <div className="flex items-center space-x-2 text-sm mb-3 px-3">
                  <User className="h-4 w-4" />
                  <span>歡迎, {user?.username}</span>
                </div>
                <Button
                  variant="outline"
                  className="w-full border-white/20 text-white hover:bg-white/10 bg-white/5"
              onClick={handleLogout}
            >
                  <LogOut className="mr-2 h-4 w-4" />
              登出
            </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavigationBar;
